import { getCompanies } from "@/getters/getCompanies";
import clsx from "classnames";

export const Companies = ({ className }) => {
  const companies = getCompanies();

  return (
    <div className={clsx(className)}>
      <h3 className="h6 mb-4 pb-2 text-white">Other Companies</h3>
      <div className="d-flex justify-content-between gap-4">
        {companies.map((i) => (
          <a key={i.id} href={i.url}>
            <img className="w-100" src={i.logo_dark} alt={i.title} />
          </a>
        ))}
      </div>
    </div>
  );
};
